export default __webpack_public_path__ + "img/images-row.ff6bc4e0.svg";